import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7529b416"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7529b416')) {
      api.createRecord('7529b416', component.options)
    } else {
      api.reload('7529b416', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=7529b416", function () {
      api.rerender('7529b416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/App.vue"
export default component.exports